export default __webpack_public_path__ + "static/media/7.7974f7b7.jpg";